<template>
  <b-modal
    ref="modal"
    :title="title"
    modal-class="spdo-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @hide="$emit('input', false)"
  >
    <v-form @submit.prevent="submit">
      <div
        class="v-application spdo-modal__body pt-0"
        :class="{'pt-4': isAddModal}"
      >
        <div

          class="input-block input-block_white"
        >
          <label class="input-block__label">E-mail</label>
          <v-text-field
            v-if="isAddModal"
            v-model="user.email"
            type="email"
            autocomplete="off"
            hide-details
            required
            solo
          />
          <div
            v-else
            class="title primary--text"
          >
            {{ user.email }}
          </div>
        </div>
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('common.name') }}
          </label>
          <v-text-field
            v-model="user.name"
            :disabled="isEditModal && ssoUser"
            autocomplete="off"
            hide-details
            solo
          />
        </div>
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('common.role') }}
          </label>
          <v-select
            v-model="user.role"
            :disabled="isEditModal && ssoUser"
            :items="roles"
            item-text="name"
            hide-details
            elevation="0"
            multiple
            autocomplete="off"
            :label="$t('common.select_role')"
            solo
          />
        </div>
        <div class="input-block input-block_white">
          <label class="input-block__label">
            ASDB
          </label>
          <v-text-field
            v-model="user.asdb"
            :disabled="isEditModal && ssoUser"
            hide-details
            solo
          />
        </div>
        <div
          v-if="isEditModal && !ssoUser"
          class="input-block input-block_white"
        >
          <label class="input-block__label">
            {{ $t('common.password') }}
          </label>
          <v-text-field
            v-model="user.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :placeholder="$t('common.password_placeholder')"
            autocomplete="new-password"
            hide-details
            solo
            @click:append="showPassword = !showPassword"
          />
        </div>
        <div
          v-if="isEditModal && ssoUser"
          class="title primary--text"
        >
          {{ $t(`common.wlsUserEdit`) }}
        </div>
      </div>
      <div class="v-application d-flex">
        <v-btn
          v-if="isAddModal || !ssoUser"
          color="primary"
          class="mr-4 flex-grow-1"
          :loading="loading"
          outlined
          large
          type="submit"
          :disabled="submitDisabled || loading"
        >
          <v-icon
            v-if="isAddModal"
            left
          >
            mdi-plus
          </v-icon>
          {{ $t(isAddModal ? 'common.add' : 'common.save') }}
        </v-btn>
        <v-btn
          v-if="isEditModal && (authUser.id !== user.id)"
          color="primary"
          class="mr-4 flex-grow-1"
          :loading="loading"
          outlined
          large
          :disabled="submitDisabled || loading"
          @click="remove()"
        >
          {{ $t('common.delete') }}
        </v-btn>
        <v-btn
          class="flex-grow-1"
          outlined
          large
          @click="$refs.modal.hide()"
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    userSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    loading: false,
    showPassword: false,
    user: {
      email: '',
      name: '',
      asdb: '',
      role: '',
      password: '',
    },
    roles: [],
  }),
  computed: {
    ...mapState({ authUser: 'user' }),
    title() {
      return this.isAddModal ? this.$t('views.user_list.adding_user') : this.$t('views.user_list.editing_user');
    },
    submitDisabled() {
      return false;
    },
    isAddModal() {
      return this.type === 'add';
    },
    isEditModal() {
      return this.type === 'edit';
    },
    ssoUser() {
      return this.user.wslId && !(this.user.wslId || '').match(/^local\//);
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.updateForm();
        this.$refs.modal.show();
      } else {
        this.$emit('input', false);
      }
    },
  },
  created() {
    this.getRoles();
  },
  methods: {
    updateForm() {
      this.user = { ...(this.isAddModal ? this.$options.data().user : this.userSelected) };
    },
    async getRoles() {
      const { data } = await this.$http.get('roles');
      this.roles = data.rows;
    },
    async submit() {
      this.loading = true;

      const params = { ...this.user, login: this.user.email.toLowerCase() };
      params.role = this.user.role;

      if (!this.user.password) {
        delete params.password;
      }

      if (this.isAddModal) {
        await this.$http.post('users', params).finally(() => {
          this.loading = false;
        });
      } else {
        await this.$http.put(`users/${this.user.id}`, params).finally(() => {
          this.loading = false;
        });
      }
      this.$refs.modal.hide();
      this.$emit('submit');
    },

    async remove() {
      this.loading = true;

      await this.$http.delete(`users/${this.user.id}`).finally(() => {
        this.loading = false;
      });

      this.$refs.modal.hide();
      this.$emit('submit');
    },
  },
};
</script>
